// 注意: 出码引擎注入的临时变量默认都以 "__$$" 开头，禁止在搭建的代码中直接访问。
// 例外：react 框架的导出名和各种组件名除外。
import React from "react";
import ChipEdit from 'ChipEdit';
import chipDataTransform from 'chipDataTransform';


import { LayoutComponent } from "@ifeng/lowcode_basic/src/components/layout/LayoutComponent/index.tsx";

import { ImageLink } from "@ifeng/lowcode_basic/src/components/popular/ImageLink/index.tsx";

import { Nav_1 } from "@ifeng/lowcode_basic/src/components/nav/Nav_1/index.tsx";

import { Container } from "@ifeng/lowcode_basic/src/components/layout/Container/index.tsx";

import { Row } from "@ifeng/lowcode_basic/src/components/layout/Row/index.tsx";

import { Col } from "@ifeng/lowcode_basic/src/components/layout/Col/index.tsx";

import { Title } from "@ifeng/lowcode_basic/src/components/popular/Title/index.tsx";

import { NewsList_1 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_1/index.tsx";

import { Swiper_1 } from "@ifeng/lowcode_basic/src/components/Swiper/Swiper_1/index.tsx";

import { VideoList_1 } from "@ifeng/lowcode_basic/src/components/video/VideoList_1/index.tsx";

import { NewsList_12 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_12/index.tsx";

import { Tabs } from "@ifeng/lowcode_basic/src/components/layout/Tabs/index.tsx";

import {
  TabPanel,
  Timeline,
  Swiper_5,
} from "@ifeng/lowcode_basic/src/index.tsx";

import { AtomText } from "@ifeng/lowcode_basic/src/components/atom/AtomText/index.tsx";

import { DateTabs } from "@ifeng/lowcode_business/src/index.tsx";

import { NewsList_2 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_2/index.tsx";

import { NewsList_11 } from "@ifeng/lowcode_basic/src/components/NewsList/NewsList_11/index.tsx";

import { Comment } from "@ifeng/lowcode_basic/src/components/popular/Comment/index.tsx";

import { Footer } from "@ifeng/lowcode_basic/src/components/popular/Footer/index.tsx";

import utils from "../../utils";

import "./index.css";

class Layout$$Page extends React.Component {
  _context = this;

  constructor(props, context) {
    super(props);

    this.utils = utils;

    this.state = {};
  }

  $ = () => null;

  $$ = () => [];

  componentDidMount() {}

  render() {
    const __$$context = this._context || this;
    const { state } = __$$context;
    return (
      <div style={{ overflowX: "hidden" }} hoverStyle="">
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl8lkjm3v1i"
          hoverStyle=""
        >
          <ImageLink
            image="https://x0.ifengimg.com/ucms/2022_42/7EE5989FAA19F388BD54862460851297709213A6_size506_w1920_h350.png"
            url=""
            isBlock={true}
            width={300}
            height={350}
            objectFit="cover"
            style={{
              display: "block",
              backgroundPositionX: "center",
              backgroundPositionY: "center",
              backgroundSize: "cover",
            }}
            hoverStyle=""
          />
          <Nav_1
            navChip={{
              $data: true,
              id: "260390",
              type: "struct",
              title: "导航内容",
              default: { type: "struct", id: "260297" },
              uuid: "11fad7e3",
              force: 1665485175962,
            }}
            mainWidth={1000}
            height={80}
            backgroundColor="#d41e26"
            isHasLeftImage={true}
            isSubTitleUnderline={true}
            subTitleHoverColor="#ffffff"
            subTitleStyle={{
              color: "#ffffff",
              fontSize: "16px",
              fontWeight: 400,
            }}
            titleStyle={{
              color: "#ffffff",
              fontSize: "24px",
              fontWeight: 700,
              lineHeight: "28px",
              width: "20px",
            }}
            leftImageUrl="https://x0.ifengimg.com/ucms/2022_42/F97C21F25CC12931F992999D5ABA015D2C64A8AF_size66_w1754_h417.png"
            leftImageStyle={{ marginRight: "80px" }}
            isSticky={false}
            style={{ paddingRight: "20px", paddingLeft: "20px" }}
            hoverStyle=""
            leftImageWidth={120}
          />
        </LayoutComponent>
        <Container width={1200} isCenter={true} hoverStyle="">
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8lkjm3v1o"
            hoverStyle=""
          >
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              hoverStyle=""
              style={{}}
            >
              <Col
                width={{ size: 800, type: "px" }}
                style={{
                  paddingRight: "20px",
                  marginTop: "40px",
                  marginBottom: "20px",
                }}
                hoverStyle=""
              >
                <Title
                  text=""
                  height={40}
                  image="https://x0.ifengimg.com/ucms/2022_42/D4ED769DA7A128E7B5F4A32A72807E4668AA89C0_size2_w780_h40.png"
                  textAlign="flex-start"
                  textStyle={{
                    fontWeight: 700,
                    fontSize: "26px",
                    marginRight: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    marginRight: "20px",
                    marginBottom: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                  isTextHasIcon={false}
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "286648",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "d62fdc84",
                    force: 1665647755917,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    fontWeight: 700,
                    lineHeight: "26px",
                    paddingBottom: "15px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  hoverStyle=""
                  style={{ paddingRight: "20px" }}
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderColor: "#dadada",
                  }}
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "286243",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "4e98551f",
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "26px",
                    lineHeight: "26px",
                    fontWeight: 400,
                    marginBottom: "15px",
                  }}
                  subTitleGroupSize={3}
                  subTitleStyle={{
                    fontSize: "14px",
                    lineHeight: "26px",
                    fontWeight: 400,
                  }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px", paddingBottom: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    borderBottomStyleType: "solid",
                    borderBottomStyleColor: "#ebebeb",
                    marginTop: "24px",
                    borderStyle: "none",
                  }}
                  nodeId="node_ocl8u2cvve1o"
                />
                <Title
                  text=""
                  height={40}
                  image="https://x0.ifengimg.com/ucms/2022_42/0D6F87CE85A3531769DCD18B5CB34330476A478A_size2_w781_h40.png"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#c33430",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    backgroundColor: "#ffffff",
                    marginRight: "20px",
                    marginBottom: "20px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  hoverStyle=""
                />
                <NewsList_1
                  newsChip={{
                    $data: true,
                    id: "286253",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285838" },
                    uuid: "234e4ddf",
                    force: 1664890261714,
                  }}
                  hoverColor="#ba2636"
                  titleStyle={{
                    color: "#2b2b2b",
                    fontSize: "14px",
                    lineHeight: "26px",
                  }}
                  subTitleGroupSize={2}
                  subTitleStyle={{ fontSize: "14px", lineHeight: "26px" }}
                  isHasThumbnail={false}
                  thumbnailWidth={140}
                  thumbnailHeight={100}
                  thumbnailStyle={{ marginRight: "20px" }}
                  style={{ paddingRight: "20px" }}
                  hoverStyle=""
                  itemStyle={{
                    paddingBottom: "24px",
                    marginTop: "24px",
                    borderBottomWidth: "1px",
                    borderBottomStyle: "solid",
                    borderBottomColor: "#ebebeb",
                  }}
                />
              </Col>
              <Col
                width={{ size: 380, type: "px" }}
                style={{ marginBottom: "20px", marginTop: "40px" }}
                hoverStyle=""
              >
                <Title
                  text=""
                  height={40}
                  image="https://x0.ifengimg.com/ucms/2022_42/7CEDD426E1BF5655EEF60A07E61992AAACF873F2_size8_w380_h40.png"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{
                    marginTop: "30px",
                    height: "40px",
                    marginBottom: "20px",
                  }}
                  hoverStyle=""
                />
                <Swiper_1
                  swiperChip={{
                    $data: true,
                    id: "286258",
                    type: "recommend",
                    title: "轮播图内容",
                    default: { type: "recommend", id: "285915" },
                    uuid: "b0376023",
                  }}
                  height={213}
                  loop={false}
                  isHasNav={false}
                  leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                  rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                  navWidth={15}
                  navHeight={20}
                  navY={85}
                  navX={10}
                  isAutoPlay={true}
                  autoSpeed={3000}
                  skin={1}
                  isHasTitle={true}
                  titleHeight={36}
                  titleStyle={{
                    background: "linear-gradient(180deg,transparent,#000)",
                    color: "#fff",
                    fontSize: "14px",
                    paddingLeft: "15px",
                    paddingRight: "15px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  isHasPagination={false}
                  paginationPosition="titleBottom"
                  paginationNormalStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    borderTopLeftRadius: "50px",
                    borderTopRightRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderBottomRightRadius: "50px",
                    width: "4px",
                    height: "4px",
                    marginLeft: "4px",
                    marginRight: "4px",
                  }}
                  paginationActiveStyle={{
                    borderTopLeftRadius: "2px",
                    borderTopRightRadius: "2px",
                    borderBottomLeftRadius: "2px",
                    borderBottomRightRadius: "2px",
                    width: "12px",
                  }}
                  paginationTotalStyle={{ marginBottom: "10px" }}
                  style={{}}
                  hoverStyle=""
                />
                <Title
                  text=""
                  height={40}
                  image="https://x0.ifengimg.com/ucms/2022_42/4A324C1FA73410774159FBDC2376BCBC3E919669_size9_w380_h40.png"
                  textAlign="flex-start"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#ffffff",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ marginTop: "20px", height: "40px" }}
                  hoverStyle=""
                />
                <VideoList_1
                  videoChip={{
                    $data: true,
                    id: "286242",
                    type: "recommend",
                    title: "视频列表",
                    format: { filter: ["title", "posterUrl", "videoPlayUrl"] },
                    default: { type: "recommend", id: "285924" },
                    uuid: "3bd6b446",
                    force: 1665406260756,
                  }}
                  width={380}
                  height={213}
                  autoPlay={false}
                  controls={true}
                  hoverColor="#ba2636"
                  skin={0}
                  continuePlay={false}
                  style={{ marginTop: "20px" }}
                  listHeight={48}
                  listIcon="https://x2.ifengimg.com/fe/custom/xghg25/video.559ac347.png"
                  listIconWidth={14}
                  listIconHeight={9}
                  listStyle={{
                    paddingLeft: "0px",
                    paddingRight: "10px",
                    height: "36px",
                    fontSize: "14px",
                    color: "#2b2b2b",
                  }}
                  hoverStyle=""
                />
              </Col>
            </Row>
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl97vfjsq1"
            hoverStyle=""
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/294892668600031960BA18E3D36742CA8A3AE489_size11_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "286656",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "61fa3058",
                force: 1665720794046,
              }}
              colNum={2}
              thumbnailWidth={590}
              thumbnailHeight={332}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                paddingRight: "0px",
                paddingBottom: "15px",
                textAlign: "justify",
                borderBottomWidth: "1px",
                borderBottomColor: "#e6e5e6",
                borderBottomStyle: "solid",
                marginLeft: "20px",
                marginRight: "20px",
              }}
              showSummary={true}
              summaryRows={6}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                paddingTop: "20px",
                paddingLeft: "20px",
                paddingRight: "20px",
                textAlign: "justify",
                fontWeight: 400,
                paddingBottom: "20px",
                lineHeight: "26px",
              }}
              moreText=""
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={0}
              style={{ borderBottomStyle: "none", paddingBottom: "20px" }}
              hoverStyle=""
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees77"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/45F3974F0B2E470F018EF154B826806E4A6223F5_size11_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "286255",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "65489e21",
                force: 1664891756405,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                paddingLeft: "0px",
                paddingRight: "0px",
                textAlign: "justify",
                borderBottomWidth: "1px",
                borderBottomColor: "#e6e5e6",
                borderBottomStyle: "solid",
                marginLeft: "20px",
                marginRight: "20px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingBottom: "15px",
              }}
              showSummary={true}
              summaryRows={3}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "26px",
                paddingLeft: "20px",
                paddingRight: "20px",
                textAlign: "justify",
                paddingTop: "10px",
                paddingBottom: "15px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={2}
              style={{ borderBottomStyle: "none", paddingBottom: "10px" }}
              hoverStyle=""
              titleHeight={50}
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl8u8dees94"
            hoverStyle=""
          >
            <Tabs
              tabList={[
                { title: "政治局委员", id: "1" },
                { title: "中共中央书记处书记", id: "2" },
                {
                  id: "1cf3c426-8638-4e96-bd5a-2fb19e408084",
                  title: "中共中央军事委员会",
                },
                {
                  id: "72456240-d599-47a7-9f39-98e3a81ef883",
                  title: "中共中央纪律委员会",
                },
              ]}
              tabWidth={300}
              tabHeight={50}
              tabGap={10}
              contentGap={20}
              tabStyle={{
                backgroundColor: "#cecece",
                fontSize: "24px",
                color: "#ffffff",
                fontWeight: 700,
                fontStyle: "normal",
              }}
              tabActiveStyle={{
                color: "#f7f6fb",
                backgroundImage:
                  "url(https://x0.ifengimg.com/ucms/2022_42/70996CB5BC09998D444296D903E9C57CF8729BAA_size17_w300_h50.png)",
              }}
              hoverStyle=""
              style={{ paddingBottom: "20px" }}
              nodeId="node_ocl93liwsy5j"
            >
              <TabPanel panelId="1">
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: 286191,
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "5864ec26",
                    force: 1666529788850,
                  }}
                  colNum={8}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={false}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "10px",
                    textAlign: "center",
                    paddingTop: "10px",
                    borderBottomStyle: "none",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingRight: "15px",
                    marginLeft: "0px",
                    paddingLeft: "15px",
                  }}
                  isFormatImage={true}
                  formatImageType={0}
                  itemStyle={{ borderBottomStyle: "none" }}
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="2">
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: 286251,
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "157063f8",
                    force: 1666529867989,
                  }}
                  colNum={8}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "10px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    fontWeight: 400,
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingTop: "10px",
                    paddingBottom: "10px",
                    paddingRight: "10px",
                    marginLeft: "0px",
                    paddingLeft: "10px",
                  }}
                  isFormatImage={true}
                  formatImageType={0}
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="1cf3c426-8638-4e96-bd5a-2fb19e408084">
                <AtomText
                  content="中央军事委员会主席"
                  style={{
                    position: "absolute",
                    marginTop: "30px",
                    color: "#c33430",
                    fontWeight: 700,
                    display: "block",
                    fontSize: "24px",
                    paddingLeft: "490px",
                  }}
                  hoverStyle=""
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: 286250,
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "501d7060",
                    force: 1666530059754,
                  }}
                  colNum={8}
                  thumbnailWidth={223}
                  thumbnailHeight={273}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "10px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingBottom: "30px",
                    paddingRight: "10px",
                    marginLeft: "0px",
                    paddingLeft: "483px",
                    paddingTop: "80px",
                  }}
                  isFormatImage={true}
                  formatImageType={2}
                  hoverStyle=""
                />
                <AtomText
                  content="中央军事委员会主席副主席"
                  hoverStyle=""
                  style={{
                    display: "block",
                    marginTop: "30px",
                    position: "absolute",
                    fontSize: "20px",
                    color: "#c33430",
                    fontWeight: 700,
                    paddingLeft: "300px",
                    width: "140px",
                    textAlign: "center",
                  }}
                />
                <AtomText
                  content="中央军事委员会主席副主席"
                  hoverStyle=""
                  style={{
                    display: "block",
                    fontSize: "20px",
                    fontWeight: 700,
                    textAlign: "center",
                    position: "absolute",
                    marginTop: "30px",
                    width: "140px",
                    paddingLeft: "770px",
                    color: "#c33430",
                  }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: 286256,
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "deedf9f6",
                    force: 1666530114624,
                  }}
                  colNum={2}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "10px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingBottom: "10px",
                    marginLeft: "0px",
                    paddingLeft: "300px",
                    paddingRight: "300px",
                    paddingTop: "100px",
                  }}
                  isFormatImage={true}
                  formatImageType={2}
                  hoverStyle=""
                />
                <Title
                  text="中央军事委员会委员"
                  height={48}
                  image=""
                  textAlign="center"
                  textStyle={{
                    paddingLeft: "24px",
                    color: "#929191",
                    fontWeight: 700,
                    fontSize: "20px",
                  }}
                  isHasAddonAfter={false}
                  addonAfterText="更多"
                  addonAfterTextStyle={{
                    fontSize: "14px",
                    color: "#ffffff",
                    textDecoration: "underline",
                  }}
                  style={{ backgroundColor: " #f9f9f9", paddingTop: "40px" }}
                  hoverStyle=""
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: 286261,
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "94ed0643",
                    force: 1666530170866,
                  }}
                  colNum={4}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "10px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingTop: "20px",
                    marginLeft: "0px",
                    paddingLeft: "300px",
                    paddingRight: "300px",
                  }}
                  isFormatImage={true}
                  formatImageType={2}
                  hoverStyle=""
                />
              </TabPanel>
              <TabPanel panelId="72456240-d599-47a7-9f39-98e3a81ef883">
                <AtomText
                  content="书记"
                  hoverStyle=""
                  style={{
                    display: "block",
                    fontSize: "24px",
                    position: "absolute",
                    marginTop: "30px",
                    fontWeight: 700,
                    paddingLeft: "570px",
                    color: "#c33430",
                  }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "287233",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "e1209073",
                    force: 1666493595200,
                  }}
                  colNum={8}
                  thumbnailWidth={223}
                  thumbnailHeight={273}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                    paddingTop: "10px",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingBottom: "30px",
                    paddingRight: "10px",
                    marginLeft: "0px",
                    paddingLeft: "483px",
                    paddingTop: "80px",
                  }}
                  isFormatImage={true}
                  formatImageType={2}
                  hoverStyle=""
                />
                <AtomText
                  content="副书记"
                  hoverStyle=""
                  style={{
                    marginTop: "30px",
                    display: "block",
                    position: "absolute",
                    color: "#c33430",
                    fontWeight: 700,
                    fontSize: "24px",
                    paddingLeft: "570px",
                  }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "286621",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "cf8f54dc",
                    force: 1666530369799,
                  }}
                  colNum={8}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "10px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingBottom: "20px",
                    paddingRight: "10px",
                    marginLeft: "0px",
                    paddingLeft: "10px",
                    borderBottomWidth: "1px",
                    borderBottomColor: "#cac8e6",
                    borderBottomStyle: "solid",
                    paddingTop: "90px",
                  }}
                  isFormatImage={true}
                  formatImageType={1}
                  hoverStyle=""
                />
                <AtomText
                  content="常务委员会委员"
                  hoverStyle=""
                  style={{
                    marginTop: "50px",
                    display: "block",
                    fontSize: "24px",
                    fontWeight: 700,
                    color: "#c33430",
                    position: "absolute",
                    paddingLeft: "520px",
                  }}
                />
                <AtomText
                  content="（按姓氏笔画排列）"
                  hoverStyle=""
                  style={{
                    display: "block",
                    fontSize: "18px",
                    color: "rgba(166,166,166,0.96)",
                    position: "absolute",
                    paddingTop: "90px",
                    paddingLeft: "520px",
                  }}
                />
                <NewsList_12
                  newsChip={{
                    $data: true,
                    id: "287234",
                    type: "recommend",
                    title: "新闻内容",
                    default: { type: "recommend", id: "285873" },
                    uuid: "47d32e55",
                    force: 1666530446570,
                  }}
                  colNum={8}
                  thumbnailWidth={130}
                  thumbnailHeight={179}
                  showThumbnailHoverScale={true}
                  isHasTitle={true}
                  titleRows={1}
                  titleHoverColor="#ba2636"
                  titleStyle={{
                    paddingTop: "6px",
                    color: "#1b4492",
                    fontSize: "16px",
                    lineHeight: "24px",
                    marginBottom: "10px",
                    textAlign: "center",
                  }}
                  showSummary={false}
                  summaryRows={3}
                  summaryStyle={{
                    color: "#666666",
                    fontSize: "14px",
                    lineHeight: "24px",
                  }}
                  moreText="[详细]"
                  moreStyle={{ color: "#ba2636" }}
                  style={{
                    flexDirection: "row",
                    position: "static",
                    justifyContent: "flex-start",
                    flexWrap: "nowrap",
                    alignItems: "flex-start",
                    backgroundColor: "#f9f9f9",
                    paddingBottom: "10px",
                    paddingRight: "10px",
                    marginLeft: "0px",
                    paddingLeft: "10px",
                    paddingTop: "150px",
                  }}
                  isFormatImage={true}
                  formatImageType={1}
                  hoverStyle=""
                />
              </TabPanel>
            </Tabs>
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl97sakbr1h"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/05D689C4935A966719A034195998D71BE8DB6342_size10_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginBottom: "20px", marginTop: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <DateTabs
              tabList={[
                {
                  id: "ff5160a7-514d-4f54-ae10-40f6710b210a",
                  title: "15",
                  isOpen: true,
                },
                { title: "16", id: "1", isOpen: true },
                { title: "17", id: "2", isOpen: true },
                {
                  id: "a56ac343-040b-4109-a3b9-0656643cd700",
                  title: "18",
                  isOpen: true,
                },
                {
                  id: "9ec6f047-c8b2-425e-bd1f-813356e8fd46",
                  title: "19",
                  isOpen: true,
                },
                {
                  id: "3ec8b061-51fc-4f05-bccb-50ba06181550",
                  title: "20",
                  isOpen: true,
                },
                {
                  id: "04c40646-46a3-4f68-baae-19e8a773291d",
                  title: "21",
                  isOpen: true,
                },
                {
                  id: "d93a708d-823a-435c-8c45-8199ed431437",
                  title: "22",
                  isOpen: true,
                },
                { isOpen: true, title: "23" },
              ]}
              tabWidth={125}
              tabHeight={50}
              tabGap={0}
              contentGap={0}
              isHasAfterTabTitle={true}
              afterTabTitleText="日"
              afterTabTitleStyle={{
                lineHeight: "41px",
                fontWeight: 100,
                fontSize: "18px",
              }}
              afterTabTitleActiveStyle={{
                fontSize: "18px",
                lineHeight: "50px",
              }}
              tabStyle={{
                color: "rgba(255, 255, 255, 0.7)",
                backgroundColor: "#D41E26",
                fontSize: "30px",
                fontWeight: "700",
                lineHeight: "41px",
              }}
              tabActiveStyle={{
                height: "62px",
                backgroundImage:
                  "url(https://x0.ifengimg.com/ucms/2022_42/854B78C617BFE3DBE58554297079F892FCFE7198_size4_w500_h248.png)",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                backgroundColor: "#ffffff",
                lineHeight: "50px",
                alignItems: "normal",
                color: "#ffffff",
              }}
              hoverStyle=""
              nodeId="node_ocl95cmpnx1"
            >
              <TabPanel
                panelId="ff5160a7-514d-4f54-ae10-40f6710b210a"
                hoverStyle=""
              >
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                  hoverStyle=""
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "286655",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "b6d36ef9",
                        force: 1665990048217,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={false}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="15日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title: "党的二十大主席团举行第一次会议",
                          desc: " 习近平出席会议并作重要讲话",
                        },
                        {
                          title: "党的二十大举行预备会议",
                          desc: "习近平主持会议",
                        },
                        {
                          title: "中国共产党第二十次全国代表大会新闻发布会",
                          desc: "大会新闻发言人回答记者提问",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        fontSize: "20px",
                        marginTop: "10px",
                        lineHeight: "30px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        marginTop: "5px",
                        lineHeight: "20px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "286654",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "81b59868",
                        force: 1665990225284,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel panelId="1" hoverStyle="">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "286638",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "f8facffd",
                        force: 1665991006709,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="16日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title: "中国共产党第二十次全国代表大会开幕会",
                          desc: "习近平代表第十九届中央委员会向党的二十大作报告",
                        },
                        {
                          title:
                            "中国共产党第二十次全国代表大会 “党代表通道”第一场采访活动",
                          desc: "",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "286637",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "eff5cd16",
                        force: 1665991106523,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel panelId="2">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287137",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "bb80a842",
                        force: 1665992198556,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="17日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title: "二十大新闻中心第一场、第二场记者招待会",
                          desc: "",
                        },
                        { title: "各代表团分组讨论二十大报告" },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287138",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "594c800f",
                        force: 1665991254821,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel panelId="a56ac343-040b-4109-a3b9-0656643cd700">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287184",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "10327e22",
                        force: 1666150168923,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="18日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title:
                            "党的二十大主席团举行第二次会议 习近平主持会议",
                          desc: "",
                        },
                        {
                          title: "二十大新闻中心举办第一场、第二场集体采访",
                          desc: "北京、天津等14个代表团的新闻发言人出席，介绍各代表团讨论党的二十大报告情况，并回答记者提问。",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287185",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "e895b775",
                        force: 1666149876688,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel
                panelId="9ec6f047-c8b2-425e-bd1f-813356e8fd46"
                hoverStyle=""
              >
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287212",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "801505ba",
                        force: 1666350846204,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="19日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        { title: "二十大新闻中心第三场记者招待会", desc: "" },
                        {
                          title: "二十大新闻中心第三场集体采访",
                          desc: "山东、河南、湖北、湖南、广东、广西、海南代表团新闻发言人出席，介绍代表团学习讨论二十大报告情况，并回答记者提问。",
                        },
                        {
                          title: "二十大新闻中心第四场集体采访",
                          desc: "重庆、四川、贵州、云南、西藏、陕西、甘肃代表团新闻发言人出席，介绍代表团学习讨论二十大报告情况，并回答记者提问。",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287213",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "19d9f793",
                        force: 1666350764565,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel panelId="3ec8b061-51fc-4f05-bccb-50ba06181550">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287215",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "61a00f0d",
                        force: 1666351124251,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="20日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        { title: "二十大新闻中心第四场记者招待会", desc: "" },
                        { title: "二十大新闻中心第五场集体采访", desc: "" },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287214",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "706405b8",
                        force: 1666351147112,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel panelId="04c40646-46a3-4f68-baae-19e8a773291d">
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287216",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "1950be36",
                        force: 1666405775640,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="21日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title: "二十大新闻中心第五场记者招待会",
                          desc: "生态环境部党组成员、副部长翟青围绕“建设人与自然和谐共生的美丽中国”主题与记者交流。",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287217",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "109a6481",
                        force: 1666405879841,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel
                panelId="d93a708d-823a-435c-8c45-8199ed431437"
                hoverStyle=""
              >
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287235",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "cde143b7",
                        force: 1666495349123,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={false}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="22日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title: "中国共产党第二十次全国代表大会在京闭幕",
                          desc: "选举产生新一届中央委员会和中央纪律检查委员会；通过关于十九届中央委员会报告的决议、关于十九届中央纪律检查委员会工作报告的决议、关于《中国共产党章程（修正案）》的决议；习近平主持大会并发表重要讲话",
                        },
                        {
                          title: "党的二十大第二场“党代表通道”采访活动",
                          desc: "",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "25px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287236",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "85077a5f",
                        force: 1666495105932,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
              <TabPanel>
                <Row
                  isCenter={true}
                  justifyContent="flex-start"
                  alignItems="stretch"
                >
                  <Col
                    width={{ size: 660, type: "px" }}
                    hoverStyle=""
                    style={{ marginRight: "20px" }}
                  >
                    <Swiper_1
                      swiperChip={{
                        $data: true,
                        id: "287242",
                        type: "recommend",
                        title: "轮播图内容",
                        default: { type: "recommend", id: "285915" },
                        uuid: "c841d098",
                        force: 1666581116133,
                      }}
                      height={450}
                      isHasNav={false}
                      leftNavImage="https://x0.ifengimg.com/ucms/2022_21/27198D15B1E76B0BF8EA2BA44F9A91596603AE9E_size0_w22_h40.png"
                      rightNavImage="https://x0.ifengimg.com/ucms/2022_21/EC3D567431E541D7FC17AABB0F45084B6D227640_size0_w22_h40.png"
                      navWidth={22}
                      navHeight={40}
                      navY={290}
                      navX={15}
                      isAutoPlay={false}
                      autoSpeed={3000}
                      isHasTitle={true}
                      titleHeight={60}
                      titleStyle={{
                        background: "linear-gradient(180deg,transparent,#000)",
                        color: "#fff",
                        fontSize: "17px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                      isHasPagination={true}
                      paginationPosition="titleBottom"
                      paginationNormalStyle={{
                        backgroundColor: "rgba(255, 255, 255, 0.5)",
                        borderTopLeftRadius: "50px",
                        borderTopRightRadius: "50px",
                        borderBottomLeftRadius: "50px",
                        borderBottomRightRadius: "50px",
                        width: "4px",
                        height: "4px",
                        marginLeft: "4px",
                        marginRight: "4px",
                      }}
                      paginationActiveStyle={{
                        borderTopLeftRadius: "2px",
                        borderTopRightRadius: "2px",
                        borderBottomLeftRadius: "2px",
                        borderBottomRightRadius: "2px",
                        width: "12px",
                      }}
                      paginationTotalStyle={{ marginBottom: "10px" }}
                      skin={1}
                      hoverStyle=""
                    />
                  </Col>
                  <Col width={{ type: "flex", size: "1" }} hoverStyle="">
                    <Title
                      text="23日议程"
                      height={45}
                      image=""
                      textAlign="center"
                      textStyle={{
                        color: "#ffffff",
                        fontWeight: 700,
                        fontSize: "24px",
                      }}
                      isTextHasIcon={false}
                      textIconHeightFull={true}
                      isHasAddonAfter={false}
                      addonAfterText="更多"
                      addonAfterTextStyle={{
                        fontSize: "14px",
                        color: "#ffffff",
                        textDecoration: "underline",
                      }}
                      hoverStyle=""
                      style={{ backgroundColor: "#D41E26" }}
                    />
                    <Timeline
                      timelineList={[
                        {
                          title:
                            "中国共产党第二十届中央政治局常委同中外记者见面",
                          desc: "",
                        },
                      ]}
                      dotWidth={8}
                      dotHeight={8}
                      dotColor="#D8D8D8"
                      isDotSolid={false}
                      dotBorderWidth={2}
                      titleStyle={{
                        fontWeight: 700,
                        color: "#080808",
                        lineHeight: "30px",
                        fontSize: "20px",
                        marginTop: "10px",
                      }}
                      descStyle={{
                        color: "rgba(33,34,35,0.62)",
                        fontSize: "16px",
                        fontWeight: 400,
                        lineHeight: "20px",
                        marginTop: "5px",
                      }}
                      hoverStyle=""
                      style={{
                        paddingTop: "20px",
                        height: "225px",
                        backgroundColor: "#F7F7F7",
                        marginBottom: "10px",
                        visible: "auto",
                        overflowY: "auto",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                      dotBorderColor="#cccccc"
                      dotLineWidth={1}
                      dotLineColor="#D8D8D8"
                    />
                    <NewsList_2
                      newsChip={{
                        $data: true,
                        id: "287243",
                        type: "recommend",
                        title: "新闻内容",
                        format: {
                          filter: [
                            "thumbnails",
                            "title",
                            "type",
                            "url",
                            "base62Id",
                            "summary",
                            "newsTime",
                            "position",
                          ],
                        },
                        default: { type: "recommend", id: "285839" },
                        uuid: "124afa1f",
                        force: 1666581085125,
                      }}
                      useMaxHeight={true}
                      maxHeight={360}
                      isHasDot={true}
                      dotStyle={{
                        marginLeft: "7px",
                        marginRight: "7px",
                        width: "6px",
                        height: "6px",
                        backgroundColor: "#D41E26",
                        borderTopLeftRadius: "0px",
                        borderTopRightRadius: "0px",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                      }}
                      titleHoverColor="#ba2636"
                      titleStyle={{ height: "38px", fontSize: "16px" }}
                      isHasTime={false}
                      skin={0}
                      hoverStyle=""
                    />
                  </Col>
                </Row>
              </TabPanel>
            </DateTabs>
          </LayoutComponent>
          <LayoutComponent
            width={1200}
            isCenter={true}
            nodeId="node_ocl98alx19i"
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/351527ACB4427A7C50C9F4C0874F216E4F277172_size10_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
          </LayoutComponent>
        </Container>
        <LayoutComponent
          isCenter={true}
          nodeId="node_ocl988i9ym2"
          hoverStyle=""
        >
          <Swiper_5
            swiperChip={{
              $data: true,
              id: "286252",
              type: "recommend",
              title: "轮播图数据",
              default: { type: "recommend", id: "286116" },
              uuid: "8fe39f24",
            }}
            swiperWidth={1200}
            height={595}
            formatImageType={0}
            isAutoPlay={true}
            autoSpeed={3000}
            isHasNav={true}
            leftNavImage="http://p2.ifengimg.com/l/2018/5/15a8462c875f75e/leftButton.png"
            rightNavImage="http://p1.ifengimg.com/l/2018/5/15a8462c875f75e/rightButton.png"
            navWidth={57}
            navHeight={64}
            navY={220}
            navX={1250}
            isHasTitle={true}
            titleLeft={0}
            titleRight={0}
            titleY={60}
            titleStyle={{
              color: "#ffffff",
              fontSize: "20px",
              lineHeight: "28px",
              backgroundColor: "rgba(0, 0, 0, 0.65)",
              paddingTop: "15px",
              paddingRight: "20px",
              paddingBottom: "15px",
              paddingLeft: "20px",
            }}
            hoverStyle=""
            style={{ marginBottom: "20px" }}
          />
        </LayoutComponent>
        <Container width={1200} isCenter={true} hoverStyle="">
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9899vnz1g2"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/2D526C3B11781F23E76FFEB5E8EF93EAE696DA02_size10_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <Tabs
              tabList={[
                { title: "大国基建", id: "1" },
                { title: "绿色低碳", id: "2" },
                {
                  id: "b4b5b2c6-0edf-4341-bfff-a10f21bbb2ba",
                  title: "航空航天",
                },
                {
                  id: "2013c2a9-49d9-4acd-acd9-f6e1a5f673b6",
                  title: "大国外交",
                },
                {
                  id: "624117c5-6e68-4079-9ed2-d5595961ff47",
                  title: "法治中国",
                },
              ]}
              tabWidth={250}
              tabHeight={35}
              tabGap={10}
              contentGap={20}
              tabStyle={{
                borderWidth: "1px",
                borderColor: "#c3c3c3",
                borderStyle: "solid",
                borderTopWidth: "1px",
                fontWeight: 400,
                fontSize: "20px",
              }}
              tabActiveStyle={{
                fontSize: "20px",
                fontWeight: 700,
                backgroundColor: "#c33430",
                color: "#ffffff",
              }}
              style={{}}
              hoverStyle=""
            >
              <TabPanel panelId="1">
                <Container isCenter={true}>
                  <Row
                    isCenter={true}
                    justifyContent="flex-start"
                    alignItems="stretch"
                    style={{ marginBottom: "20px" }}
                    hoverStyle=""
                  >
                    <Col
                      width={{ size: "1", type: "flex" }}
                      style={{ marginRight: "10px" }}
                      hoverStyle=""
                    >
                      <NewsList_12
                        newsChip={{
                          $data: true,
                          id: "287219",
                          type: "recommend",
                          title: "新闻内容",
                          default: { type: "recommend", id: "285873" },
                          uuid: "6023ae59",
                          force: 1666513260045,
                        }}
                        colNum={1}
                        thumbnailWidth={795}
                        thumbnailHeight={448}
                        showThumbnailHoverScale={false}
                        formatImageType={0}
                        isHasTitle={true}
                        titleRows={2}
                        titleHoverColor="#ba2636"
                        titleStyle={{
                          paddingTop: "15px",
                          color: "#2b2b2b",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 700,
                          marginBottom: "10px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                        }}
                        showSummary={false}
                        summaryRows={3}
                        summaryStyle={{
                          color: "#666666",
                          fontSize: "14px",
                          lineHeight: "24px",
                        }}
                        moreText="[详细]"
                        moreStyle={{ color: "#ba2636" }}
                        style={{ marginBottom: "10px" }}
                        hoverStyle=""
                      />
                    </Col>
                    <Col
                      width={{ size: 340, type: "px" }}
                      style={{
                        paddingLeft: "20px",
                        paddingTop: "20px",
                        paddingRight: "20px",
                        borderWidth: "1px",
                        borderColor: "#ccc",
                        borderStyle: "solid",
                        marginBottom: "10px",
                        paddingBottom: "0px",
                        width: "340px",
                        height: "425px",
                      }}
                      hoverStyle=""
                    >
                      <AtomText
                        content="十年来，中国综合立体交通网加速成型，建成了全球最大的高速铁路网、高速公路网、世界级港口群，航空航海通达全球。&#10;&#10;"
                        style={{
                          color: "#666",
                          marginTop: "20px",
                          display: "block",
                          fontSize: "20px",
                          lineHeight: "32px",
                          textAlign: "justify",
                        }}
                        hoverStyle=""
                      />
                    </Col>
                  </Row>
                  <NewsList_12
                    newsChip={{
                      $data: true,
                      id: "287221",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285873" },
                      uuid: "8d936d4b",
                      force: 1666510797633,
                    }}
                    colNum={3}
                    thumbnailWidth={383}
                    thumbnailHeight={215}
                    showThumbnailHoverScale={false}
                    formatImageType={0}
                    isHasTitle={true}
                    titleRows={2}
                    titleHoverColor="#ba2636"
                    titleStyle={{
                      paddingTop: "15px",
                      color: "#2b2b2b",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 700,
                      marginBottom: "10px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                    showSummary={false}
                    summaryRows={3}
                    summaryStyle={{
                      color: "#666666",
                      fontSize: "14px",
                      lineHeight: "24px",
                    }}
                    moreText="[详细]"
                    moreStyle={{ color: "#ba2636" }}
                    hoverStyle=""
                  />
                </Container>
              </TabPanel>
              <TabPanel panelId="2">
                <Container isCenter={true}>
                  <Row
                    isCenter={true}
                    justifyContent="flex-start"
                    alignItems="stretch"
                    style={{ marginBottom: "20px" }}
                    hoverStyle=""
                  >
                    <Col
                      width={{ size: "1", type: "flex" }}
                      style={{ marginRight: "10px" }}
                    >
                      <NewsList_12
                        newsChip={{
                          $data: true,
                          id: "287220",
                          type: "recommend",
                          title: "新闻内容",
                          default: { type: "recommend", id: "285873" },
                          uuid: "a6d2ff18",
                          force: 1666509758160,
                        }}
                        colNum={1}
                        thumbnailWidth={795}
                        thumbnailHeight={448}
                        showThumbnailHoverScale={false}
                        formatImageType={0}
                        isHasTitle={true}
                        titleRows={2}
                        titleHoverColor="#ba2636"
                        titleStyle={{
                          paddingTop: "15px",
                          color: "#2b2b2b",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 700,
                          marginBottom: "10px",
                          paddingLeft: "10px",
                        }}
                        showSummary={false}
                        summaryRows={3}
                        summaryStyle={{
                          color: "#666666",
                          fontSize: "14px",
                          lineHeight: "24px",
                        }}
                        moreText="[详细]"
                        moreStyle={{ color: "#ba2636" }}
                        style={{ marginBottom: "10px" }}
                        hoverStyle=""
                        itemStyle={{}}
                      />
                    </Col>
                    <Col
                      width={{ size: 340, type: "px" }}
                      style={{
                        paddingLeft: "20px",
                        paddingTop: "20px",
                        paddingRight: "20px",
                        borderWidth: "1px",
                        borderColor: "#ccc",
                        borderStyle: "solid",
                        marginBottom: "10px",
                        paddingBottom: "0px",
                        width: "340px",
                        height: "425px",
                      }}
                    >
                      <AtomText
                        content="2021年1月，三江源国家公园正式成立，同时祁连山国家公园体制试点任务已全面完成，目前正在努力创建青海湖国家公园，青海省以国家公园为主体的自然保护体系建设取得了显著的成效。"
                        style={{
                          fontSize: "20px",
                          color: "#666",
                          lineHeight: "32px",
                          marginTop: "20px",
                          display: "block",
                          textAlign: "justify",
                        }}
                        hoverStyle=""
                      />
                    </Col>
                  </Row>
                  <NewsList_12
                    newsChip={{
                      $data: true,
                      id: "287222",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285873" },
                      uuid: "59d5fc2e",
                      force: 1666509679049,
                    }}
                    colNum={3}
                    thumbnailWidth={383}
                    thumbnailHeight={215}
                    showThumbnailHoverScale={false}
                    formatImageType={2}
                    isHasTitle={true}
                    titleRows={2}
                    titleHoverColor="#ba2636"
                    titleStyle={{
                      paddingTop: "15px",
                      color: "#2b2b2b",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 700,
                      marginBottom: "10px",
                      paddingLeft: "10px",
                    }}
                    showSummary={false}
                    summaryRows={3}
                    summaryStyle={{
                      color: "#666666",
                      fontSize: "14px",
                      lineHeight: "24px",
                    }}
                    moreText="[详细]"
                    moreStyle={{ color: "#ba2636" }}
                    hoverStyle=""
                    style={{}}
                  />
                </Container>
              </TabPanel>
              <TabPanel panelId="b4b5b2c6-0edf-4341-bfff-a10f21bbb2ba">
                <Container isCenter={true}>
                  <Row
                    isCenter={true}
                    justifyContent="flex-start"
                    alignItems="stretch"
                    style={{ marginBottom: "20px" }}
                    hoverStyle=""
                  >
                    <Col
                      width={{ size: "1", type: "flex" }}
                      style={{ marginRight: "10px" }}
                    >
                      <NewsList_12
                        newsChip={{
                          $data: true,
                          id: "287223",
                          type: "recommend",
                          title: "新闻内容",
                          default: { type: "recommend", id: "285873" },
                          uuid: "5d870477",
                          force: 1666508499218,
                        }}
                        colNum={1}
                        thumbnailWidth={795}
                        thumbnailHeight={448}
                        showThumbnailHoverScale={false}
                        formatImageType={2}
                        isHasTitle={true}
                        titleRows={2}
                        titleHoverColor="#ba2636"
                        titleStyle={{
                          paddingTop: "15px",
                          color: "#2b2b2b",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 700,
                          marginBottom: "10px",
                          paddingLeft: "10px",
                        }}
                        showSummary={false}
                        summaryRows={3}
                        summaryStyle={{
                          color: "#666666",
                          fontSize: "14px",
                          lineHeight: "24px",
                        }}
                        moreText="[详细]"
                        moreStyle={{ color: "#ba2636" }}
                        style={{ marginBottom: "10px" }}
                        hoverStyle=""
                      />
                    </Col>
                    <Col
                      width={{ size: 340, type: "px" }}
                      style={{
                        paddingLeft: "20px",
                        paddingTop: "20px",
                        paddingRight: "20px",
                        borderWidth: "1px",
                        borderColor: "#ccc",
                        borderStyle: "solid",
                        marginBottom: "10px",
                        paddingBottom: "0px",
                        width: "340px",
                        height: "425px",
                      }}
                      hoverStyle=""
                    >
                      <AtomText
                        content="十年来，中国航天用硬核实力对古老的故事传说进行了全新诠释与精彩演绎，将古人对灿烂星河的憧憬与后人对浩瀚宇宙的探索牵连，将现代科技与传统文化完美融合，让“神话”走进现实。"
                        style={{
                          fontSize: "20px",
                          color: "#666",
                          lineHeight: "32px",
                          marginTop: "20px",
                          display: "block",
                          textAlign: "justify",
                        }}
                        hoverStyle=""
                      />
                    </Col>
                  </Row>
                  <NewsList_12
                    newsChip={{
                      $data: true,
                      id: "287224",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285873" },
                      uuid: "c5d480c8",
                      force: 1666510597144,
                    }}
                    colNum={3}
                    thumbnailWidth={383}
                    thumbnailHeight={215}
                    showThumbnailHoverScale={false}
                    formatImageType={0}
                    isHasTitle={true}
                    titleRows={2}
                    titleHoverColor="#ba2636"
                    titleStyle={{
                      paddingTop: "15px",
                      color: "#2b2b2b",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 700,
                      marginBottom: "10px",
                      paddingLeft: "10px",
                    }}
                    showSummary={false}
                    summaryRows={3}
                    summaryStyle={{
                      color: "#666666",
                      fontSize: "14px",
                      lineHeight: "24px",
                    }}
                    moreText="[详细]"
                    moreStyle={{ color: "#ba2636" }}
                    hoverStyle=""
                  />
                </Container>
              </TabPanel>
              <TabPanel panelId="2013c2a9-49d9-4acd-acd9-f6e1a5f673b6">
                <Container isCenter={true}>
                  <Row
                    isCenter={true}
                    justifyContent="flex-start"
                    alignItems="stretch"
                    style={{ marginBottom: "20px" }}
                  >
                    <Col
                      width={{ size: "1", type: "flex" }}
                      style={{ marginRight: "10px" }}
                      hoverStyle=""
                    >
                      <NewsList_12
                        newsChip={{
                          $data: true,
                          id: "287225",
                          type: "recommend",
                          title: "新闻内容",
                          default: { type: "recommend", id: "285873" },
                          uuid: "37cfb5b9",
                          force: 1666512178752,
                        }}
                        colNum={1}
                        thumbnailWidth={795}
                        thumbnailHeight={448}
                        showThumbnailHoverScale={false}
                        formatImageType={1}
                        isHasTitle={true}
                        titleRows={2}
                        titleHoverColor="#ba2636"
                        titleStyle={{
                          paddingTop: "15px",
                          color: "#2b2b2b",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 700,
                          marginBottom: "10px",
                          paddingLeft: "10px",
                        }}
                        showSummary={false}
                        summaryRows={3}
                        summaryStyle={{
                          color: "#666666",
                          fontSize: "14px",
                          lineHeight: "24px",
                        }}
                        moreText="[详细]"
                        moreStyle={{ color: "#ba2636" }}
                        style={{ marginBottom: "10px" }}
                        hoverStyle=""
                      />
                    </Col>
                    <Col
                      width={{ size: 340, type: "px" }}
                      style={{
                        paddingLeft: "20px",
                        paddingTop: "20px",
                        paddingRight: "20px",
                        borderWidth: "1px",
                        borderColor: "#ccc",
                        borderStyle: "solid",
                        marginBottom: "10px",
                        paddingBottom: "0px",
                        width: "340px",
                        height: "425px",
                      }}
                    >
                      <AtomText
                        content="习近平在报告中指出，十年来，我们全面推进中国特色大国外交，推动构建人类命运共同体，坚定维护国际公平正义，倡导践行真正的多边主义，旗帜鲜明反对一切霸权主义和强权政治，毫不动摇反对任何单边主义、保护主义、霸凌行径。"
                        style={{
                          fontSize: "20px",
                          color: "#666",
                          lineHeight: "32px",
                          marginTop: "20px",
                          display: "block",
                          textAlign: "justify",
                        }}
                        hoverStyle=""
                      />
                    </Col>
                  </Row>
                  <NewsList_12
                    newsChip={{
                      $data: true,
                      id: "287226",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285873" },
                      uuid: "55c54df1",
                      force: 1666511378323,
                    }}
                    colNum={3}
                    thumbnailWidth={383}
                    thumbnailHeight={215}
                    showThumbnailHoverScale={false}
                    formatImageType={0}
                    isHasTitle={true}
                    titleRows={2}
                    titleHoverColor="#ba2636"
                    titleStyle={{
                      paddingTop: "15px",
                      color: "#2b2b2b",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 700,
                      marginBottom: "10px",
                      paddingLeft: "10px",
                      paddingRight: "10px",
                    }}
                    showSummary={false}
                    summaryRows={3}
                    summaryStyle={{
                      color: "#666666",
                      fontSize: "14px",
                      lineHeight: "24px",
                    }}
                    moreText="[详细]"
                    moreStyle={{ color: "#ba2636" }}
                    hoverStyle=""
                  />
                </Container>
              </TabPanel>
              <TabPanel panelId="624117c5-6e68-4079-9ed2-d5595961ff47">
                <Container isCenter={true}>
                  <Row
                    isCenter={true}
                    justifyContent="flex-start"
                    alignItems="stretch"
                    style={{ marginBottom: "20px" }}
                  >
                    <Col
                      width={{ size: "1", type: "flex" }}
                      style={{ marginRight: "10px" }}
                    >
                      <NewsList_12
                        newsChip={{
                          $data: true,
                          id: "287227",
                          type: "recommend",
                          title: "新闻内容",
                          default: { type: "recommend", id: "285873" },
                          uuid: "feffc5ed",
                          force: 1666508092014,
                        }}
                        colNum={1}
                        thumbnailWidth={795}
                        thumbnailHeight={448}
                        showThumbnailHoverScale={false}
                        formatImageType={1}
                        isHasTitle={true}
                        titleRows={2}
                        titleHoverColor="#ba2636"
                        titleStyle={{
                          paddingTop: "15px",
                          color: "#2b2b2b",
                          fontSize: "18px",
                          lineHeight: "24px",
                          fontWeight: 700,
                          marginBottom: "10px",
                          paddingLeft: "10px",
                        }}
                        showSummary={false}
                        summaryRows={3}
                        summaryStyle={{
                          color: "#666666",
                          fontSize: "14px",
                          lineHeight: "24px",
                        }}
                        moreText="[详细]"
                        moreStyle={{ color: "#ba2636" }}
                        style={{ marginBottom: "10px" }}
                        hoverStyle=""
                      />
                    </Col>
                    <Col
                      width={{ size: 340, type: "px" }}
                      style={{
                        paddingLeft: "20px",
                        paddingTop: "20px",
                        paddingRight: "20px",
                        borderWidth: "1px",
                        borderColor: "#ccc",
                        borderStyle: "solid",
                        marginBottom: "10px",
                        paddingBottom: "0px",
                        width: "340px",
                        height: "425px",
                      }}
                      hoverStyle=""
                    >
                      <AtomText
                        content="中央政法委副秘书长訚柏表示：习近平总书记在党的二十大开幕会上的报告中23次提到了“法治”，这充分体现了党中央对法治工作的高度重视。"
                        style={{
                          fontSize: "20px",
                          color: "#666",
                          marginTop: "20px",
                          display: "block",
                          textAlign: "justify",
                          lineHeight: "32px",
                        }}
                        hoverStyle=""
                      />
                    </Col>
                  </Row>
                  <NewsList_12
                    newsChip={{
                      $data: true,
                      id: "287228",
                      type: "recommend",
                      title: "新闻内容",
                      default: { type: "recommend", id: "285873" },
                      uuid: "4c4d74f6",
                      force: 1666508009335,
                    }}
                    colNum={3}
                    thumbnailWidth={383}
                    thumbnailHeight={215}
                    showThumbnailHoverScale={false}
                    formatImageType={0}
                    isHasTitle={true}
                    titleRows={2}
                    titleHoverColor="#ba2636"
                    titleStyle={{
                      paddingTop: "15px",
                      color: "#2b2b2b",
                      fontSize: "18px",
                      lineHeight: "24px",
                      fontWeight: 700,
                      marginBottom: "10px",
                      paddingLeft: "10px",
                    }}
                    showSummary={false}
                    summaryRows={3}
                    summaryStyle={{
                      color: "#666666",
                      fontSize: "14px",
                      lineHeight: "24px",
                    }}
                    moreText="[详细]"
                    moreStyle={{ color: "#ba2636" }}
                    hoverStyle=""
                  />
                </Container>
              </TabPanel>
            </Tabs>
            <Row
              isCenter={true}
              justifyContent="flex-start"
              alignItems="stretch"
              style={{ marginBottom: "20px" }}
            >
              <Col
                width={{ size: "1", type: "flex" }}
                style={{ marginRight: "10px" }}
              />
            </Row>
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9jc6ijp1"
            hoverStyle=""
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/18F6D5488461402D7901AB43936275BAAE2423EE_size10_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <NewsList_11
              newsChip={{
                $data: true,
                id: "287218",
                type: "recommend",
                title: "新闻内容",
                format: {
                  filter: [
                    "thumbnails",
                    "title",
                    "type",
                    "url",
                    "base62Id",
                    "summary",
                    "children",
                    "position",
                    "newsTime",
                  ],
                },
                default: { type: "recommend", id: "285873" },
                uuid: "a9dea538",
                force: 1666409278108,
              }}
              colNum={2}
              colPadding={35}
              showColBorder={true}
              itemStyle={{ paddingTop: "15px", paddingBottom: "15px" }}
              itemAlignCenter={false}
              itemHoverColor="#ba2636"
              showThumbnail={true}
              thumbnailWidth={300}
              thumbnailHeight={200}
              showThumbnailHoverScale={true}
              titleStyle={{
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
              }}
              showSummary={true}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "24px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              showTime={false}
              timeStyle={{
                color: "#666666",
                fontSize: "12px",
                lineHeight: "24px",
              }}
              hoverStyle=""
              style={{
                textAlign: "justify",
                paddingRight: "10px",
                marginBottom: "20px",
              }}
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl9ksctaz1"
            hoverStyle=""
            style={{ paddingTop: "20px" }}
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_44/9D54D7623248043C80F328BC088C397F9317DC44_size11_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <NewsList_12
              newsChip={{
                $data: true,
                id: "287240",
                type: "recommend",
                title: "新闻内容",
                default: { type: "recommend", id: "285873" },
                uuid: "34277c79",
                force: 1666496795365,
              }}
              colNum={3}
              thumbnailWidth={383}
              thumbnailHeight={215}
              showThumbnailHoverScale={true}
              isHasTitle={true}
              titleRows={2}
              titleHoverColor="#ba2636"
              titleStyle={{
                paddingTop: "15px",
                color: "#2b2b2b",
                fontSize: "18px",
                lineHeight: "24px",
                fontWeight: 700,
                marginBottom: "10px",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
              showSummary={false}
              summaryRows={3}
              summaryStyle={{
                color: "#666666",
                fontSize: "14px",
                lineHeight: "24px",
              }}
              moreText="[详细]"
              moreStyle={{ color: "#ba2636" }}
              itemStyle={{
                borderColor: "#ebebeb",
                borderWidth: "1px",
                borderStyle: "solid",
              }}
              formatImageType={2}
            />
          </LayoutComponent>
          <LayoutComponent
            isCenter={true}
            nodeId="node_ocl97sakbr1i"
            hoverStyle=""
            style={{ paddingBottom: "20px" }}
          >
            <Title
              text=""
              height={40}
              image="https://x0.ifengimg.com/ucms/2022_42/ACD1FEE36B01E6A7B0178201943E0D2A6C682CCF_size11_w1192_h40.png"
              textAlign="flex-start"
              textStyle={{ paddingLeft: "24px", fontWeight: 700 }}
              isHasAddonAfter={false}
              addonAfterText="更多"
              addonAfterTextStyle={{
                fontSize: "14px",
                color: "#ffffff",
                textDecoration: "underline",
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
              isTextHasIcon={false}
              hoverStyle=""
            />
            <Comment
              url="https://news.ifeng.com/loc/mainland/special/20th"
              title="中共二十大"
              hoverStyle=""
              style={{ marginBottom: "1px" }}
            />
          </LayoutComponent>
        </Container>
        <Footer year="2022" style={{ marginTop: "70px" }} hoverStyle="" />
      <ChipEdit transform={chipDataTransform} />
</div>
    );
  }
}

export default Layout$$Page;

function __$$eval(expr) {
  try {
    return expr();
  } catch (error) {}
}

function __$$evalArray(expr) {
  const res = __$$eval(expr);
  return Array.isArray(res) ? res : [];
}

function __$$createChildContext(oldContext, ext) {
  const childContext = {
    ...oldContext,
    ...ext,
  };
  childContext.__proto__ = oldContext;
  return childContext;
}
